module.exports = __webpack_public_path__ + "static/img/rich.5d175f9.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dailyFreeCash/rich.webp
// module id = YbDf
// module chunks = 0